var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7,10.8h-2.5v-9c0-0.4-0.3-0.7-0.5-0.8s-0.6-0.1-1,0.1c-0.2,0.1-0.8,0.5-1.8,0.5c-0.6,0-0.9-0.1-1.3-0.3h0 c-0.5-0.2-1-0.5-2-0.5c-1,0-1.6,0.3-2,0.5h0C5.1,1.5,4.8,1.7,4.2,1.7c-1,0-1.6-0.4-1.8-0.5C2,0.9,1.6,0.9,1.4,1 C1.1,1.2,0.8,1.4,0.8,1.9V16c0,0.1,0,0.2,0,0.4c0,0.3,0.1,0.7,0.3,1.1c0.2,0.4,0.5,0.8,1,1.2c0.5,0.3,1.1,0.5,1.9,0.5h11.7 c0.2,0,0.3,0,0.5,0c0.3,0,0.7-0.1,1.1-0.3c0.4-0.2,0.8-0.5,1.2-1c0.3-0.5,0.5-1.1,0.5-1.9v-2.5C19.2,12,18,10.8,16.7,10.8z  M4.2,17.5c-0.5,0-0.8-0.1-1-0.2c-0.2-0.1-0.4-0.3-0.5-0.5c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.2,0-0.2l0-12.8 c0.5,0.1,1,0.3,1.7,0.3c1,0,1.6-0.3,2-0.5l0,0c0.4-0.2,0.6-0.3,1.3-0.3c0.6,0,0.9,0.1,1.3,0.3l0,0c0.5,0.2,1,0.5,2,0.5 c0.7,0,1.2-0.1,1.7-0.3v12.8c0,0.7,0.1,1.2,0.4,1.7H4.2z M17.5,15.8c0,0.5-0.1,0.8-0.2,1c-0.1,0.2-0.3,0.4-0.5,0.5 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.2-0.5-0.5 c-0.1-0.2-0.2-0.5-0.2-1v-3.3h2.5c0.5,0,0.8,0.4,0.8,0.8V15.8z M10,5.8H5c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h5 c0.5,0,0.8-0.4,0.8-0.8C10.8,6.2,10.5,5.8,10,5.8z M10,9.2H5c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h5c0.5,0,0.8-0.4,0.8-0.8 C10.8,9.5,10.5,9.2,10,9.2z M10,12.5H5c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h5c0.5,0,0.8-0.4,0.8-0.8 C10.8,12.9,10.5,12.5,10,12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.67b461db2efa74b4fdf526a1beb55495.svg";
export { ForwardRef as ReactComponent };